module.exports = __webpack_public_path__ + "static/media/flooring_allImpact_60y_n.9cac9058.csv";